import React from 'react';
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import TrackingResults from "../../components/TrackingDetails/TrackingDetails";


const trackingDetails = () => (
  <div className="wrapper">
    <Breadcrumbs/>
    <TrackingResults/>
  </div>
);

export default trackingDetails;


// WEBPACK FOOTER //
// ./src/pages/manage/TrackingDetails.js